// Audits: the list (run, track, compare) and the report.
export default {
  liste: {
    sousTitre: 'Dated, comparable audits',
    intro: 'Each audit captures a dated, comparable state of the brand.',
    analyseSeule: 'Analysis only',
    analyseSeuleTitre: 'Analysis only: re-analyses the brand on the data already collected, with no new collection and no new AI presence measurement. Quick.',
    whiteSpacesTitre: 'Detects the white space now, on the signals already stored, without rerunning a full analysis. Replaces the previous auto-detected white space.',
    cascadeTitre: 'Also include the child brands in the hierarchy. Unticked: the selected brand only.',
    recalculerTitre: 'Recalculates the Brand Strength (4R) of the focal brand and its descendants on the signals already stored, including the cluster average (competitors’ average per dimension). No new collection.',
    recalculer: 'Recalculate 4R',
    resyncTitre: 'Migration: deletes the old manually entered solar systems, reattaches the planets directly to the galaxy and re-detects the territories. Irreversible.',
    resync: 'Resync territories',
    dejaEnCours: 'An audit is already running for this brand',
    profondTitre: 'Deep audit: new collection (official accounts + competitors), then a full analysis. If the data is recent, collection is skipped automatically. It also measures AI presence (what the assistants say about the brand), for around one dollar.',
    enCoursBouton: 'Audit running…',
    lancerProfond: 'Run a deep audit',
    lectureSeule: 'Your role ({role}) is read-only on this screen: running an audit requires the {analyst} role. Ask an administrator of your organisation to upgrade it.',
    roleInconnu: 'unknown',
    collecteEnCours: 'Collection in progress · {n} sources | Collection in progress · {n} source | Collection in progress · {n} sources',
    suppressionImpossible: 'Could not delete',
    lancementImpossible: 'Could not start',
    detectionImpossible: 'Detection failed',
    resyncImpossible: 'Resync failed',
    recalculImpossible: 'Recalculation failed',
    confirmerSuppression: 'Delete this audit ({profondeur}, {date})?\n\nThe snapshot it produced and the analysis data are kept: only the run record is removed. This cannot be undone.',
    wsDetectes: '{n} white spaces detected: {liste} | {n} white space detected: {liste} | {n} white spaces detected: {liste}',
    wsItem: '‘{label}’ ({score}) - {nom}',
    aucunWs: 'No white space detected.',
    wsEchecs: 'Failures: {liste}',
    confirmerResync: 'Resynchronise this galaxy’s territories?\n\n• deletes the manually entered solar systems\n• reattaches the planets directly to the galaxy\n• re-detects the territories (galaxy + planets)\n\nThis cannot be undone.',
    resyncFait: 'Resync done: {planetes} planet(s) reattached · {systemes} solar system(s) deleted · {territoires} territory link(s) made.',
    recalcule: 'Brand Strength (4R) recalculated: the cluster average now follows the competitors’ average per dimension.',
    etapes: {
      rescue_similarity: 'Exclusion rescue',
      sentiment: 'Sentiment scoring',
      official_accounts: 'Official account ingestion',
      cluster_estimate: 'External competitors',
      personas: 'Personas',
      territoires: 'Brand territories',
      brand_strength: 'Brand Strength Score',
      white_spaces: 'White space detection',
      calendar: 'Cultural calendar',
      presence_llm: 'AI presence',
    },
    statuts: {
      pending: 'waiting',
      running: 'running',
      done: 'completed',
      error: 'error',
    },
    declencheurs: {
      manual: 'manual',
      wizard: 'wizard',
      autopilot: 'autopilot',
      scheduler: 'scheduled',
    },
    profondeurs: {
      leger: 'light',
      profond: 'deep',
    },
    colProfondeur: 'Depth',
    colStatut: 'Status',
    colLance: 'Started',
    colDuree: 'Duration',
    sansResultat: 'no result: {liste}',
    restitutionTitre: 'Opens the report for THIS audit: a scrollable presentation, ready to share in a meeting',
    restitution: 'Report',
    tourneEncore: 'This audit is still running: wait for it to finish before removing it.',
    supprimerTitre: 'Delete this audit (the snapshot it produced and the analysis data remain). Irreversible.',
    colMarque: 'Brand',
    colDeclencheur: 'Trigger',
    colSignaux: 'Signals',
    colDelta: 'Score delta',
    colDate: 'Date',
    chargement: 'Loading…',
    aucunSnapshot: 'No snapshot: run a full analysis from Brand V3 to create the first audit.',
    comparaison: 'Comparison · {marque} - latest snapshot vs previous',
    scorePrecedent: 'Brand score · previous',
    scoreDate: 'Brand score · {date}',
    baisse: 'The drop in {dim} ({delta}) is the strongest negative signal: a deep-dive is recommended.',
    ouvrir: 'Open →',
  },
  rapport: {
    aujourdhui: 'today',
    dansJours: 'in {n} d',
    dansMois: 'in {n} mo',
    hubIndice: '{mentions} mentions · {auteurs} distinct authors',
    provenanceCetAudit: 'Measured during this audit, on {date}.',
    provenanceLeger: 'Measured on {date}, the last measurement before this audit: a light audit does not repeat it.',
    provenanceAvant: 'Measured on {date}, the last measurement before this audit.',
    provenanceDerniere: 'Latest measurement, on {date}.',
    et: '{debut} and {fin}',
    introSalut: 'Hi, I’m {nom}.',
    introAge: 'I’m between {tranche} years old.',
    introAgeEt: ' and ',
    introReste: 'What keeps me here? {jtbd}',
    introPartir: 'What would make me leave? {tension}',
    transition: 'And here is {nom}: {suite}. →',
    aPeineArrive: 'only just arrived, to be validated',
    transitionFin: 'Now you know them. Time to talk to them. ↓',
    concurrent: 'Competitor',
    decisionDefaut: 'Invest in the ‘{label}’ territory: the space is free, and the signal is measured.',
    signauxConstruits: 'built from your audience',
    preparation: 'Preparing the report…',
    basculerTheme: 'Toggle dark / light',
    ouvrirOrion: 'Open in Orion →',
    restitutionAudit: 'Audit report',
    bssInfo: 'Weighted 4R average, rolling 90-day window, normalised against the reference cluster',
    depuisLe: 'since {date}',
    analyseComplete: 'full analysis',
    lesPersonas: 'The personas',
    personnesRegardent: '{n} people are watching your brand. | {n} person is watching your brand. | {n} people are watching your brand.',
    portraitEnCours: 'portrait being generated…',
    aValider: 'to validate',
    partAudience: 'audience share',
    confiance: 'confidence',
    quatreSignaux: 'The four signals',
    titreSignaux: 'Four signals.',
    titreSignauxLimitant: 'Four signals. One limiting factor.',
    tiennent: '{liste} hold up against the cluster: {limitant} caps the score. | {liste} holds up against the cluster: {limitant} caps the score. | {liste} hold up against the cluster: {limitant} caps the score.',
    autresSignaux: 'The other signals',
    compareCluster: 'Each signal is compared with the reference cluster.',
    facteurLimitant: 'limiting factor',
    levier: '{dim} is at {v} against {avg} for the cluster: the priority lever for the next cycle.',
    methodoTitre: 'Scores normalised 0-100 against the reference cluster: methodology in the deep-dive',
    aucunScore: 'No score computed: run a full audit.',
    presenceIA: 'AI presence',
    presenceTitre: '{n}/100 in AI assistants.',
    presenceTitreSans: 'What the assistants know about you.',
    presenceSous: 'What {assistants} answer when asked for advice in your category, without your name being mentioned. {provenance}',
    lesAssistants: 'the assistants',
    muetTitre: 'No answer (key or credits): this is not ‘does not cite’',
    indisponible: 'unavailable',
    citeeSpontanement: 'cited unprompted: {pct}%',
    echecCetAudit: 'This audit’s measurement did not complete ({raison}).',
    echecPrecedente: 'This audit’s measurement did not complete ({raison}): the previous one is shown.',
    pasMesuree: 'AI presence could not be measured.',
    raison: 'Reason: {raison}. Its failure did not stop the audit, and it will be measured again at the next deep audit.',
    voirReponses: 'See each answer →',
    carrefours: 'Audience crossroads',
    audienceDit: 'What your audience says.',
    lesTerritoires: 'The territories',
    vitSur: '{marque} spans {n} territories. | {marque} spans {n} territory. | {marque} spans {n} territories.',
    segments: 'The market segments detected in your signals: the study panel is anchored in their sector studies.',
    deLaMarque: 'of the brand',
    detectesAudit: 'detected at audit · shared across brands · backed by public sector studies',
    territoire: 'Territory',
    espaceLibreL1: 'A space',
    espaceLibreL2: 'is free.',
    cielL1: 'Your audience',
    cielL2: 'sky.',
    clusterEmerge: 'The ‘{label}’ cluster is emerging, and nobody has settled on it yet.',
    recouvrement: 'Maximum overlap: {pct}% ({nom}).',
    sansWs: 'Your brand and its audience overlaps with its cluster. No white space detected yet: it will appear here as soon as the signals reveal it. Once your audience is large enough, rerun an analysis.',
    clusterEmergent: 'emerging cluster · to validate',
    carteComplete: 'full map →',
    espaceLibre: 'Free space',
    leCalendrier: 'The calendar',
    aNePasManquer: 'Not to be missed.',
    ouvrirCalendrier: 'Open the project calendar →',
    laDecision: 'The decision',
    genererPourDecision: 'Generate the brief to turn these signals into an action decision.',
    ouvrirBrief: 'Open the brief',
    genererBrief: 'Generate the brief',
    lancerBlast: 'Launch BLAST',
    generee: 'Orion · report generated on {date}',
  },
}
